import { z } from "zod";

export const FormSchema = z.object({
  cpf: z
    .string()
    .nonempty("O CPF é obrigatório")
    .regex(/^\d{11}$/, "CPF deve conter exatamente 11 dígitos numéricos"),
  nome: z.string().nonempty("O Nome é obrigatório"),
  matricula: z
    .string()
    .nonempty("A Matrícula é obrigatória")
    .regex(/^\d+$/, "A Matrícula deve conter apenas números"),
  cargo: z.string().nonempty("O Cargo é obrigatório"),
});

export type FormData = z.infer<typeof FormSchema>;
